import styled from 'styled-components';
import { Col, Card, Form } from 'antd';

export const FormItem = styled(Form.Item)`
	margin: 0;
	padding: 0;
	width: 100%;
	height: 100%;

	.ant-form-item-row {
		height: 100%;
	}

	.ant-form-item-control-input {
		height: 100%;
	}

	.ant-form-item-control-input-content {
		height: 100%;
	}
`;

export const ScoreCard = styled(Card)`
	text-align: center;
	border-radius: 8px;

	.ant-card-body {
		padding: 16px;
	}
`;

export const CategoryCard = styled(Card)`
	border-radius: 8px;
	margin-bottom: 16px;
`;

export const ElementsContainer = styled(Col)`
	padding: 16px;
	background-color: #fafafa;
	border-radius: 8px;
`;
